var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import id from "@irati/utils/id";
import { LangLoader, FormattedMessage } from "@irati/utils/lang";
import Icon from "@irati/ui/src/Icon";
import { bodyText } from "@irati/ui/src/global/css/text";
import { Label } from "@irati/ui/src/Typography";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
var PerksGOHighlightWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  flex-direction: column;\n\n  > span {\n    margin-top: 8px;\n  }\n"], ["\n  ", "\n  display: flex;\n  flex-direction: column;\n\n  > span {\n    margin-top: 8px;\n  }\n"])), bodyText);
var PerksGOHighlight = /** @class */ (function (_super) {
    __extends(PerksGOHighlight, _super);
    function PerksGOHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            hasLinkedCards: undefined
        };
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ hasLinkedCards: linkedCards.length > 0 });
            });
        };
        return _this;
    }
    PerksGOHighlight.prototype.render = function () {
        var _a = this.state, hasLinkedCards = _a.hasLinkedCards, load = _a.load;
        var idNamespace = id("deal-highlight-row", this.props);
        return (React.createElement(LangLoader, { bucket: PERKSGO },
            React.createElement(Loading, { load: load },
                React.createElement(PerksGOHighlightWrapper, { id: idNamespace },
                    React.createElement(Icon, { icon: "perksGO", size: 40 }),
                    hasLinkedCards ? (React.createElement(Label, { color: "contrast" },
                        React.createElement(FormattedMessage, { id: "perksgo.perksGOHighlight.hasCards" }))) : (React.createElement(FormattedMessage, { id: "perksgo.perksGOHighlight.noCard" }))))));
    };
    return PerksGOHighlight;
}(PureComponent));
export default PerksGOHighlight;
var templateObject_1;
